if($('.type-detail').length){

        if($('a[href="/klient/"]').length){
            var priceListId = getShoptetDataLayer('customer').priceListId;
            var productCode = $('#product-detail-form meta[itemprop="sku"]').attr('content');
            $.ajax({
                url: 'https://api.latop.cz/api/get_pricelist.php',
                type: 'GET',
                data: {
                    priceListId: priceListId,
                    productCode: productCode
                },
                success: function(response) {
                    if (response.error) {
                        console.error('Error: ' + response.error);
                    } else {
                        var priceRatio = response.price_ratio
                        if(priceRatio<1){
                            $('.p-final-price-wrapper').hide()
                            var fullPriceVat = response.price_vat
                            var priceStandart = fullPriceVat*priceRatio
                            var pricebezdph = priceStandart/1.21
                            var sleva = parseFloat(fullPriceVat/1.21)-parseFloat(pricebezdph)
                            var procentualniSleva = Math.round((1-parseFloat(priceRatio))*100)
                            var newPrice = '<div class="new-price">'
                            newPrice += '<div class="price-row"><div class="left">Doporučená cena bez DPH:</div><div class="right"><span class="doporucena">'+Number(fullPriceVat/1.21).ShoptetFormatAsCurrency()+'</span></div></div>'
                            newPrice += '<div class="price-row"><div class="left">Sleva '+procentualniSleva+'%:</div><div class="right"><span class="sleva">'+Number(sleva).ShoptetFormatAsCurrency()+'</span></div></div>'
                            newPrice += '<div class="price-row last"><div class="left">Cena po slevě:</div><div class="right"><span class="cenaPoSleve">'+Number(pricebezdph).ShoptetFormatAsCurrency()+' bez DPH</span><span class="cenaDPH">'+Number(priceStandart).ShoptetFormatAsCurrency()+' s dph</span></div></div>'
                            newPrice += '</div>'
                            $('.p-final-price-wrapper').after(newPrice)
                        }
                    }
                },
                error: function(xhr, status, error) {
                    // Zpracování chyby
                    $('#productData').html('<p>An error occurred: ' + error + '</p>');
                }
            });
        }
        else{
                $('.p-final-price-wrapper').hide()
                $(this).hide()
                var standartPrice = parseFloat($('.p-final-price-wrapper .price-standard span').text().replace(/ /, ''))
                var pricesph = $('.p-final-price-wrapper .price-final').text().split('/')[0]
                var pricebezdph = $('.p-final-price-wrapper .price-additional').text().split('bez')[0]
                var sleva = standartPrice-parseFloat(pricesph.replace(/ /g, '').replace(',', '.'))
                var procentualniSleva = 100-(Math.floor(100*parseFloat($('.p-final-price-wrapper .price-final').text().split('/')[0].trim().replace(/ /g, ''))/standartPrice))
                var newPrice = '<div class="new-price">'
                if($('.p-final-price-wrapper .price-standard').length){
                    newPrice += '<div class="price-row"><div class="left">Běžná cena s DPH:</div><div class="right"><span class="doporucena">'+Number(standartPrice).ShoptetFormatAsCurrency()+'</span></div></div>'
                    newPrice += '<div class="price-row"><div class="left">Sleva:</div><div class="right"><span class="sleva">'+Number(sleva).ShoptetFormatAsCurrency()+'</span></div></div>'
                    newPrice += '<div class="price-row last"><div class="left">Cena po slevě:</div><div class="right"><span class="cenaPoSleve">'+pricesph+' s DPH</span><span class="cenaDPH">'+pricebezdph+' bez dph</span></div></div>'
                }
                else{
                    newPrice += '<div class="price-row last"><div class="left">Cena:</div><div class="right"><span class="cenaPoSleve">'+pricesph+' s DPH</span><span class="cenaDPH">'+pricebezdph+' bez dph</span></div></div>'
                }
                newPrice += '</div>'
                $('.p-final-price-wrapper').after(newPrice)
        }
    




    if($('.product-top .flag-vypnuti-kusu').length>0){
        $('.product-top .availability-amount').remove();
    };
    // Funkce pro stahování souboru
   /* function stahnoutSoubor(url, callback) {
        $.ajax({
            url: url,
            type: "GET",
            dataType: "json",
            success: function (data) {
                callback(data);
            },
            error: function () {
                console.error("Chyba při stahování souboru.");
            }
        });
    }

    // Cesta k souboru
    var cestaKsouboru = "/user/documents/cleaned_products.json";

    // Stáhnout soubor a uložit ho do seassionStorage do jediného klíče
    stahnoutSoubor(cestaKsouboru, function (data) {
        if (Array.isArray(data)) {
            // Vytvořte pole pro uložení dat
            var dataProUlozeni = [];

            data.forEach(function (produkt) {
                if (produkt.CODE) {
                    dataProUlozeni.push(produkt);
                }
            });

            // Uložte pole dat do seassionStorage
            sessionStorage.setItem("cleaned_products", JSON.stringify(dataProUlozeni));

            console.log("Soubor byl úspěšně stažen a uložen do seassionStorage pod klíčem 'cleaned_products'.");
        } else {
            console.error("Soubor neobsahuje očekávanou strukturu pole objektů.");
        }
    });*/
  
        // Načtení hodnoty sku z meta značky
       /* if($('a[href="/klient/"]').length){
            var sku = $('#product-detail-form meta[itemprop="sku"]').attr('content');

            // Načtení dat z sessionStorage
            var cleanedProductsData = sessionStorage.getItem("cleaned_products");
            if (cleanedProductsData) {
                var cleanedProducts = JSON.parse(cleanedProductsData);
    
                // Projděte data a hledejte shodu s sku
                for (var i = 0; i < cleanedProducts.length; i++) {
                    if (cleanedProducts[i].CODE === sku) {
                        var produkt = cleanedProducts[i];
                        $.each(produkt.PRICELISTS.PRICELIST, function(index, pricelist) {
                            // Porovnejte TITLE s getShoptetDataLayer('customer').fullName
                            var customerName = getShoptetDataLayer('customer').priceListId;
                           
                            if (pricelist.ID == customerName) {
                                var priceRatio = pricelist.PRICE_RATIO
                                
                                if(priceRatio<1){
                                    $('.p-final-price-wrapper').hide()
                                    var fullPriceVat = pricelist.PRICE_VAT
                                    var priceStandart = fullPriceVat*priceRatio
                                    var pricebezdph = priceStandart/1.21
                                    var sleva = parseFloat(fullPriceVat/1.21)-parseFloat(pricebezdph)
                                    var procentualniSleva = Math.round((1-parseFloat(priceRatio))*100)
                                    var newPrice = '<div class="new-price">'
                                    newPrice += '<div class="price-row"><div class="left">Doporučená cena bez DPH:</div><div class="right"><span class="doporucena">'+Number(fullPriceVat/1.21).ShoptetFormatAsCurrency()+'</span></div></div>'
                                    newPrice += '<div class="price-row"><div class="left">Sleva '+procentualniSleva+'%:</div><div class="right"><span class="sleva">'+Number(sleva).ShoptetFormatAsCurrency()+'</span></div></div>'
                                    newPrice += '<div class="price-row last"><div class="left">Cena po slevě:</div><div class="right"><span class="cenaPoSleve">'+Number(pricebezdph).ShoptetFormatAsCurrency()+' bez DPH</span><span class="cenaDPH">'+Number(priceStandart).ShoptetFormatAsCurrency()+' s dph</span></div></div>'
                                    newPrice += '</div>'
                                    $('.p-final-price-wrapper').after(newPrice)
                                }
                                
                                return false; // Ukončete each loop, protože jste našli shodu
                            }
                          
                            
                        });
                        break; // Pokud byl produkt nalezen, ukončete hledání
                    }
                    
                }
            } else {
                console.error("Není k dispozici uložená data pro cleaned_products.");
            }
        }
        else{
            $('.p-final-price-wrapper').hide()
            $(this).hide()
            var standartPrice = parseFloat($('.p-final-price-wrapper .price-standard span').text().replace(/ /, ''))
            var pricesph = $('.p-final-price-wrapper .price-final').text().split('/')[0]
            var pricebezdph = $('.p-final-price-wrapper .price-additional').text().split('bez')[0]
            var sleva = standartPrice-parseFloat(pricesph.replace(/ /g, '').replace(',', '.'))
            var procentualniSleva = 100-(Math.floor(100*parseFloat($('.p-final-price-wrapper .price-final').text().split('/')[0].trim().replace(/ /g, ''))/standartPrice))
            var newPrice = '<div class="new-price">'
            if($('.p-final-price-wrapper .price-standard').length){
                newPrice += '<div class="price-row"><div class="left">Běžná cena s DPH:</div><div class="right"><span class="doporucena">'+Number(standartPrice).ShoptetFormatAsCurrency()+'</span></div></div>'
                newPrice += '<div class="price-row"><div class="left">Sleva:</div><div class="right"><span class="sleva">'+Number(sleva).ShoptetFormatAsCurrency()+'</span></div></div>'
                newPrice += '<div class="price-row last"><div class="left">Cena po slevě:</div><div class="right"><span class="cenaPoSleve">'+pricesph+' s DPH</span><span class="cenaDPH">'+pricebezdph+' bez dph</span></div></div>'
            }
            else{
                newPrice += '<div class="price-row last"><div class="left">Cena:</div><div class="right"><span class="cenaPoSleve">'+pricesph+' s DPH</span><span class="cenaDPH">'+pricebezdph+' bez dph</span></div></div>'
            }
            newPrice += '</div>'
            $('.p-final-price-wrapper').after(newPrice)
        }*/
        
    if($('#product-detail-form .flag-konfigurace').length>0){
        if($('.variant-list, .surcharge-list').length>0){
            $('.p-info-wrapper').append('<div class="configurator"></div>')
            $('.variant-list select, .surcharge-list select').each(function(){
                if($(this).length>0){
                    $(this).closest('.surcharge-list, .variant-list').addClass('haveConfig')
                    var data_parameter_id = $(this).data('parameter-id')
                    var haveTooltip = $(this).closest('tr').find('.show-tooltip') 
                    var folderName = $(this).attr('data-parameter-name').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/g, '');
                    if(haveTooltip.length>0){
                        var html_var = '<div class="custom-variant"><div class="h3">'+$(this).attr('data-parameter-name')+' <span class="show-tooltip question-tooltip" title="'+haveTooltip.attr('title')+'" data-original-title="'+haveTooltip.attr('title')+'">?</span></div>'
                    }
                    else{
                        var html_var = '<div class="custom-variant"><div class="h3">'+$(this).attr('data-parameter-name')+'</div>'
                    }
                    html_var += '<div class="custom-variant-wrap" data-param-id="'+data_parameter_id+'"><div class="pseudo-selectbox"><div class="options">'
                    $(this).find('option').each(function(){
                        var data_value = $(this).attr('value')
                        if ($.isNumeric($(this).val())) {
                            html_var += '<div class="variant" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                            html_var += '<span class="lupa" image-src="/user/documents/upload/konfigurace/'+data_parameter_id+'-'+folderName+'/'+$(this).attr('value') +'.jpg"></span>'
                            html_var += '<div class="image">'
                                html_var += '<img src="/user/documents/upload/konfigurace/'+data_parameter_id+'-'+folderName+'/'+$(this).attr('value') +'.jpg" alt="'+$(this).text().split('+')[0].trim()+'">'
                            html_var += '</div>'
                            if($(this).text().indexOf('+')!== -1){
                                var textSplit = $(this).text().split('+')
                                html_var += '<div class="text">'+textSplit[0]+' <br>(+ '+textSplit[1]+')</div>'
                            }
                            else{
                                html_var += '<div class="text">'+$(this).text()+'</div>'
                            }
                            
                            html_var += '</div>'
                        }
                    })
                    html_var += '</div></div></div></div>'
                    $('.configurator').append(html_var);                 
                }
                
            })
    
            var necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;
            for (var parentKey in necessaryVariantData) {
                if (necessaryVariantData.hasOwnProperty(parentKey)) {
                    var variant = necessaryVariantData[parentKey];
                    $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').attr('data-price-id', variant.id).attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-'))
                }
            }    
        }
    
        $(document).on('click', '.variant .lupa', function(e){
            e.preventDefault();

                $.colorbox({
                    html: '<img src="' + $(this).attr('image-src') + '">',
                    width: "95%", // Procentuální šířka
                    height: "95%", // Procentuální výška
                    maxWidth: 400, // Maximální šířka
                    maxHeight: 400, // Maximální výška
                    className: "colorBoxCustomImage",
                    onComplete: function() {
                        // Pokud je potřeba provést další akce po dokončení
                    }
                });
            
        
            
        });
    
        $(document).on('click', '.custom-variant-wrap .variant', function(){
            const variantData = $(this).closest('.variant').data('value')
            const variantParameterId = $(this).closest('.variant').data('parameter-id')
            $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){return $(this).attr('value') == variantData }).change().prop("selected", true)
            var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
            var $splitParameters = $(selector);
            $splitParameters.trigger('change');
            $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
            $(this).closest('.variant').addClass("active");    
            $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
            $('.custom-variant-wrap .variant').each(function(){
                const variantData = $(this).data('value')
                const variantParameterId = $(this).data('parameter-id')
                const unavailable = $("select[data-parameter-id='"+variantParameterId+"']  option[value='" + variantData + "']").hasClass("unavailable-option")    
                if (unavailable === true) {
                    $(this).addClass("unavailable").removeClass("active")
                }
                else{
                    $(this).removeClass("unavailable")
                } 
            }) 
            $(this).closest('.pseudo-selectbox').find('.selected-option').html('<div class="selectedVariant">'+$(this).closest('.variant').html()+'</div>')      
        })
    
        $(document).on('click', '#jsUnavailableCombinationMessage a', function(){
            $('.custom-variant-wrap .variant').removeClass('unavailable')
        })
        $(document).ready(function(){
            $(".custom-variant-wrap").each(function() {
                var $variants = $(this).find("div.variant");
                if ($variants.length === 1) {
                  $variants.addClass("active");
                }
              });
            var urlParams = new URLSearchParams(window.location.search);
            var parameterValueId = urlParams.get("parameterValueId");
            var $divToHighlight = $("div.variant[data-value='" + parameterValueId + "']");
            if ($divToHighlight.length > 0) {
                $divToHighlight.addClass("active");
            }
        })

        $(".custom-variant-wrap .options").each(function () {
            var $variants = $(this).find(".variant");
            if ($variants.length > 8) {
                $variants.slice(8).hide();
                $(this).append('<button class="show-more-variants btn btn-conversion">Zobrazit více</button>');
            }
        });
        $(document).on('click', '.show-more-variants', function (e) {
            e.preventDefault();
            var $button = $(this);
            var $options = $button.closest(".options");
            $options.find(".variant:hidden").slideDown();
            $button.remove();
        });

    }
}